<template>
  <el-drawer
    id="xzt_list"
    title="统计"
    :visible.sync="drawer"
    :direction="direction"
    :withHeader="false"
    :before-close="handleClose"
  >
    <div class="header">
      统计
    </div>
    <div class="content clearfix">
      <div class="content-item">
        <el-table
        ref="tableArr"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :row-style="{ height: '0' }"
        :cell-style="changeCellStyle"
      >
        <template v-for="item in items">
          <el-table-column
            v-if="item.id == 'value'"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          >
            <template scope = "scope">
              <div v-if="scope.row.value>0" style="color:blue;">
                {{ scope.row.value }}
              </div>
              <div v-else style="color:red;">
                {{ scope.row.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="item.name"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          ></el-table-column>
        </template>
       
      </el-table>
      </div>
     
    </div>
  </el-drawer>
</template>
<script>
export default {
  data() {
    return {
      items: [
        { name: "月份", id: "name" },
        { name: "总金额", id: "value",scope:"value" },
      ],
      tableData: [],
      wsData: [],
      drawer: false,
      direction: "rtl",
      isshow: false,
    };
  },
  methods: {
    changeCellStyle(value) {
      //列的label的名称
      if (value.columnIndex === 1) {
        return "color:red;font-weight:bold;font-size:16px;height:30px;padding:0;"; //修改的样式
      } else {
        return "height:30px;padding:0;";
      }
    },
    show(value) {
      this.drawer = true;
      if (value !== undefined) {
        this.tableData = [];
        let total = 0;
        for(var k in value){
          total = total + value[k];
          this.tableData.push({
            name:k+"月",value:value[k]
          });
        }
        this.tableData.push({
            name:"总计",value:total
          });
        
      }
    },
  },
};
</script>
<style lang="less" scope>
#xzt_list {
  font-size: 20px;
  color: black;
  /deep/.el-drawer {
    min-width: 500px;
  }
  .header {
    height: 40px;
    width: 100%;
    background-image: linear-gradient(to right, #0f6ad7, #00ced4);
    padding: 0 30px;
    box-sizing: border-box;
    color: white;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
    p {
      display: inline-block;
      margin-left: 10px;
    }
  }

  .content {
    //   width: 1000px;
    //   margin: 0 auto;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 40px);
    /deep/.el-table .rowstyle {
      background: black;
    }
    .content-item{
      float: left;
      width:100%;
    }
    .title {
      font-size: 20px;
      font-weight: bold;
      &.red {
        color: rgb(245, 140, 140);
      }
      &.blue {
        color: rgb(118, 118, 242);
      }
      &.green {
        color: rgb(64, 209, 64);
      }
    }
  }
}
</style>